export default __webpack_public_path__ + "static/media/coventry-cc.a855b556.jpg";